import { render, staticRenderFns } from "./DashboardCreador.vue?vue&type=template&id=1aa3beb3&lang=true"
import script from "./DashboardCreador.vue?vue&type=script&lang=js"
export * from "./DashboardCreador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports